<main>
    <div class="container">
        <div class="row mt-5 pt-5">
            <div class="col-sm-8 pb-0">
                <div class="leftbanner-content">
                    <h1 class="d-none d-sm-block">Siste savnede og funnet dyr i ditt nærområde.</h1>
                    <p class="d-none d-sm-block">Gå inn på Savnet eller Funnet og få en oppdatert liste over savnede
                        eller funnet katter og hunder
                        som er registrert i ditt nærområde.</p>
                    <p style="display: none;">Du kan også se hvilke dyr som er blitt
                        gjenforent med sine eiere gjennom Savnet & Funnet.</p>
                    <div class="callto-action">
                        <a (click)="navigateToPath('found')" routerLinkActive="active" class="btn btn-white width-100 mb-2"
                            type="btn">{{ 'Report
                            Lost' |
                            translate }} <i class="fas fa-arrow-right"></i></a>
                        <a (click)="navigateToPath('lost')" routerLinkActive="active"
                            class="btn btn-white width-100 custom-ml-3 mb-2 mbl-xm" type="btn">{{ 'Report Found' |
                            translate }} <i class="fas fa-arrow-right"></i></a>
                    </div>
                </div>
            </div>
            <div class="col-sm-4 pb-0">
                <div class="banner-slider">
                    <img src="assets/img/banne-1.jpg" class="img-fluid" alt="" />
                    <div class="right-content">
                        <h1>Registrer dyret ditt nå.</h1>
                        <p class="mbl-hide">Slik kan du få beskjed om at dyret ditt er funnet selv før du har meldt
                            det
                            savnet.
                            <!--a href="#" class="register"/>Registrer deg her (?)</a-->
                        </p>
                        <p class="desktp-hide">Slik kan du få beskjed om at dyret ditt er funnet selv før du har
                            meldt
                            det savnet.
                            <!--a href="#" class="register"/>Registrer deg her (?)</a-->
                        </p>
                        <button class="btn btn-outlinebdr"><a target="_blank"
                                href="{{lostPath}}">Register nå</a></button>
                    </div>
                    <div class="grey-overlay-n"></div>
                </div>
            </div>
        </div>
        <app-search [homePageOperationTypeId]="1"></app-search>
    </div>
</main>